import { useCallback, useEffect, useRef, useState } from 'react';
import RModal from '../../../../../components/Rsuite/Modal';
import { Text } from '../../../../../components/Text/Text';
import { useMountings } from '../../../../../hooks/useMountings';
import { CustomCheckPicker } from '../../../../../components/CustomCheckPicker';
import { CustomButton } from '../../../../../components/CustomButton';
import { Flex } from '../../../../../components/Flex/Flex';
import { Container } from './styles';
import { createProductMountingBatch } from '../../../../../services/product_mounting/createProductMountingBatch';
import { useAuth } from '../../../../../hooks/auth';
import { getProductsByGroup } from '../../../../../services/products/getProductsByGroup';
import { toastSuccess, toastError } from '../../../../../toasts';

export function Mountings({ group, open, onClose, listProducts }) {
  const [selecteds, setSelecteds] = useState([]);
  const { mountings } = useMountings();
  const { id_empresa } = useAuth();
  const productsRef = useRef([]);

  const parseData = (data = []) => {
    return data.map((item) => ({
      label: item.Descricao,
      value: item.Id,
    }));
  };

  const loadProducts = useCallback(
    async (setProducts) => {
      if (group) {
        const response = await getProductsByGroup({
          contractNumber: id_empresa,
          groupId: group.Id,
          limit: 99999,
        });

        if (response.success) {
          setProducts(response.data);
        }
      }
    },
    [group, id_empresa],
  );

  const onChange = (newSelecteds) => {
    setSelecteds(newSelecteds);
  };

  const onSubmit = async () => {
    const productsIds = productsRef.current.map((product) => product.Id);

    const response = await createProductMountingBatch({
      companyContractNumber: id_empresa,
      mountingsIds: selecteds,
      productsIds,
    });

    if (response.success) {
      toastSuccess('Montagens aplicadas com sucesso!');
      listProducts?.();
      onClose?.();
    } else {
      toastError('Não foi possivel realizar operação!');
    }
  };

  useEffect(() => {
    loadProducts((data) => (productsRef.current = data));
  }, [loadProducts]);

  return (
    <RModal open={open} onClose={onClose} title="Montagem de Pratos">
      <Container>
        <Text variant="sub_title_1">Montagem Por Grupo</Text>
        <Flex column>
          <Text variant="info">Selecione montagens</Text>
          <CustomCheckPicker
            data={parseData(mountings)}
            style={{ width: '100%' }}
            onChange={onChange}
          />
        </Flex>

        <Flex justifyContent="flex-end">
          <CustomButton onClick={onSubmit}>Aplicar</CustomButton>
        </Flex>
      </Container>
    </RModal>
  );
}
